/** Lo que guarda cada tabla en localStorage (`ndw-tables-<modelo>`): todas las columnas del
 * selector, en el orden elegido y con si se ven o no */
export interface ColumnaGuardada {
    key: string;
    shown: boolean;
}

/**
 * Combina las columnas que la tabla puede mostrar con la configuración que guardó el usuario.
 *
 * Como lo guardado lleva todas las columnas del selector, una columna que no aparece ahí es que no
 * existía (o no se podía mostrar) cuando se guardó: sale según su valor por defecto, y en el orden
 * detrás de la que la precede en la definición de la tabla. Sin esto, quien ya hubiera tocado el
 * selector no vería nunca una columna nueva. Lo guardado de columnas que ya no se pueden mostrar
 * se ignora.
 */
export function combinarConColumnasGuardadas<T extends { key: string, visiblePorDefecto: boolean }>(
    columnas: T[],
    guardadas: ColumnaGuardada[]
): { orden: T[], mostradas: T[] } {
    const orden: T[] = [];
    for (const guardada of guardadas) {
        const columna = columnas.find(c => c.key === guardada?.key);
        if (columna && !orden.includes(columna)) {
            orden.push(columna);
        }
    }
    columnas.forEach((columna, i) => {
        if (orden.includes(columna)) {
            return;
        }
        const anterior = columnas.slice(0, i).reverse().find(c => orden.includes(c));
        orden.splice(anterior ? orden.indexOf(anterior) + 1 : 0, 0, columna);
    });
    const mostradas = orden.filter(columna => {
        const guardada = guardadas.find(g => g?.key === columna.key);
        return guardada ? guardada.shown : columna.visiblePorDefecto;
    });
    return {orden, mostradas};
}
